import { updateLinksAttributes, missingWidget } from '../utils.js';

export default function customSignupWidget() {
  const widgetName = 'customSignup';
  const widgetOpts = typeof customSignupOpts === 'undefined' ? null : customSignupOpts;
  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const $emailSignup = $('.footer .emailSignup');
      $widget.replaceWith($emailSignup);

      if (hasData) {
        updateSignupFeature(data.items, widgetName);
      } else {
        $widget.remove();
        $emailSignup.remove();
      }
    },
  });
}

function updateSignupFeature(data, idName) {
  const { Title: signupTitle, Description: signupText, URL: signupURL } = data[0];

  const containerSectionClass = 'footer-right';
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Subscribe';

  const $container = $(`.${containerSectionClass}`);
  const $signupElement = $container.find('.emailSignup');
  const $signupTextElement = $signupElement.find('.emailSignupText');

  $signupTextElement.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
      ${signupText ? `<p class="signup-description">${signupText}</p>` : ''}
    </div>
  `);

  $signupElement.attr('id', idName);
  $signupElement.attr('role', 'form');
  $signupElement.attr('aria-label', 'Sign up to the newsletter');
  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');

  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);

  const $submitLink = $signupElement.find('.emailInputSubmit a');
  if ($submitLink.length) {
    $submitLink.text(buttonLabel);
  }

  if (!signupURL) {
    return;
  }

  $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${signupURL}" class="button" ${updateLinksAttributes(signupURL, signupTitle)}>${buttonLabel}</a>
    `);
}
